
document.querySelectorAll('.measurement__in').forEach(function (element) {

    element.addEventListener('click', function (event) {

        event.preventDefault();

        this.classList.add('selected');
        this.previousElementSibling.classList.remove('selected');

        const parent = this.closest('.size-guide-section');

        parent.querySelectorAll('.inches').forEach(function (el) {
            el.style.display = 'block';
        });

        parent.querySelectorAll('.cm').forEach(function (el) {
            el.style.display = 'none';
        });

    });

});

document.querySelectorAll('.measurement__cm').forEach(function (element) {

    element.addEventListener('click', function (event) {

        event.preventDefault();

        this.classList.add('selected');

        this.nextElementSibling.classList.remove('selected');

        const parent = this.closest('.size-guide-section');

        parent.querySelectorAll('.cm').forEach(function (el) {
            el.style.display = 'block';
        });
        parent.querySelectorAll('.inches').forEach(function (el) {
            el.style.display = 'none';
        });

    });

});

var sizeSelect, i, j, sizeSelectLength, ll, selElmnt, newDiv, newDiv2, newDiv3;
sizeSelect = document.getElementsByClassName("size-select");
sizeSelectLength = sizeSelect.length;

for (i = 0; i < sizeSelectLength; i++) {

    selElmnt = sizeSelect[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;

    newDiv = document.createElement("DIV");

    newDiv.setAttribute("id", "select-selected");
    newDiv.setAttribute("value", selElmnt.options[selElmnt.selectedIndex].value);

    newDiv.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

    sizeSelect[i].appendChild(newDiv);

    newDiv2 = document.createElement("DIV");
    newDiv2.setAttribute("class", "select-items");

    for (j = 1; j < ll; j++) {

        newDiv3 = document.createElement("DIV");
        newDiv3.innerHTML = selElmnt.options[j].innerHTML;
        newDiv3.setAttribute("value", selElmnt.options[j].value);

        newDiv3.addEventListener("click", function() {

            var parentSame, i, k, selectParents, parentSibling, selectParentsLength, parentSameLength;
            selectParents = this.parentNode.parentNode.getElementsByTagName("select")[0];
            selectParentsLength = selectParents.length;
            parentSibling = this.parentNode.previousSibling;

            for (i = 0; i < selectParentsLength; i++) {

                if (selectParents.options[i].innerHTML == this.innerHTML) {
                    selectParents.selectedIndex = i;
                    parentSibling.innerHTML = this.innerHTML;
                    parentSibling.setAttribute("value", selectParents.options[i].value);
                    parentSame = this.parentNode.getElementsByClassName("same-as-selected");
                    parentSameLength = parentSame.length;

                    for (k = 0; k < parentSameLength; k++) {
                        parentSame[k].removeAttribute("class");
                    }

                    this.setAttribute("class", "same-as-selected");

                    break;
                }
            }
            parentSibling.click();
        });

        newDiv2.appendChild(newDiv3);
    }

    sizeSelect[i].appendChild(newDiv2);

    newDiv.addEventListener("click", function(e) {
        e.stopPropagation();
        this.classList.toggle("menu-open");
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-show");
        this.classList.toggle("select-arrow-active");
    });

}

function closeAllSelect(elmnt) {

    var itemList, itemSelected, i, itemListLength, itemSelectedLength, arrNo = [];

    itemList = document.getElementsByClassName("select-items");

    itemSelected = document.getElementsByClassName("select-selected");

    itemListLength = itemList.length;

    itemSelectedLength = itemSelected.length;

    for (i = 0; i < itemSelectedLength; i++) {

        if (elmnt == itemSelected[i]) {
            arrNo.push(i)
        } else {
            itemSelected[i].classList.remove("select-arrow-active");
        }

    }

    for (i = 0; i < itemListLength; i++) {

        if (arrNo.indexOf(i) === -1) {
            itemList[i].classList.add("select-hide");
        }

    }
}

const sizeDropdown = document.getElementById('select-selected'),
sizeReg = document.getElementById('size-guide-section--regular'),
sizePetite = document.getElementById('size-guide-section--petite'),
sizeTall = document.getElementById('size-guide-section--tall');

sizeDropdown.addEventListener('click', function (event) {

    const parentSizeSelect = this.closest('.size-select');
    parentSizeSelect.classList.toggle('m-lg');

    const selectedValue = event.target.getAttribute('value');

    if (selectedValue === 'regular') {
        sizeReg.style.display = 'block';
        sizePetite.style.display = 'none';
        sizeTall.style.display = 'none';
    } else if (selectedValue === 'petite') {
        sizeReg.style.display = 'none';
        sizePetite.style.display = 'block';
        sizeTall.style.display = 'none';
    } else if (selectedValue === 'tall') {
        sizeReg.style.display = 'none';
        sizePetite.style.display = 'none';
        sizeTall.style.display = 'block';
    }

});